// extracted by mini-css-extract-plugin
module.exports = {"checkcard":"CheckCard_checkcard__JzXcp","disabled":"CheckCard_disabled__1goAF","highlighted":"CheckCard_highlighted__1RFn_"};